"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.captureException = void 0;
const tslib_1 = require("tslib");
const Sentry = tslib_1.__importStar(require("@sentry/browser"));
const axiosClient_1 = require("../common/api/axiosClient");
const captureException = (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, message, severity = 'error') => {
    if (axiosClient_1.isInOcm) {
        message && Sentry.captureMessage(message, severity);
        Sentry.captureException(error);
    }
    else {
        // severity === Sentry.Severity.Error
        //   ? console.error(message, error)
        //   : console.warn(message, error);
    }
};
exports.captureException = captureException;
//# sourceMappingURL=sentry.js.map